import { StoneXRow } from '../../../StoneX';
import StoneXMainPage from '../../../StoneX/StoneXMainPage/StoneXMainPage';
import SeasonalMatrixReport from './SeasonalMatrixReport';

export default function SeasonalMatrixTool() {
  return (
    <StoneXMainPage>
      <StoneXRow>
        <h1>Seasonal Matrix</h1>
      </StoneXRow>
      <SeasonalMatrixReport />
    </StoneXMainPage>
  );
}
